<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Parametry produktów</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/parameters">Parametry produktów</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isPlOpen = !isPlOpen">
            <h5>Opis parametru produktu [pl]</h5>
            <span :class="chevronPlClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isPlOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.name_pl"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isEnOpen = !isEnOpen">
            <h5>Opis parametru produktu [en]</h5>
            <span :class="chevronEnClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.name_en"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeOpen = !isDeOpen">
            <h5>Opis parametru produktu [de]</h5>
            <span :class="chevronDeClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.name_de"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeDeOpen = !isDeDeOpen">
            <h5>Opis parametru produktu [de_de]</h5>
            <span :class="chevronDeDeClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.name_cpde"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeEnOpen = !isDeEnOpen">
            <h5>Opis parametru produktu [de_en]</h5>
            <span :class="chevronDeEnClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.name_cpen"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isConfigOpen = !isConfigOpen">
            <h5>Konfiguracja parametru produktu</h5>
            <span :class="chevronConfigClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isConfigOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa zmiennej</label>
                <div class="col-sm-10">
                  <input
                    v-model="parameterObj.var_name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa zmiennej"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.var_name" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.var_name[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/parameters">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddParameter"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { hasPermission } from "../../permissions";
import { productParameterPermissionsConst } from "../../constants/productConstants";
import { useStore } from "vuex";
import router from "../../router/router";

export default {
  name: "ParametersCreate",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const canAddParameter = computed(() =>
      hasPermission(productParameterPermissionsConst.add)
    );
    const parameterObj = ref({
      name: "",
      model: "",
      type: "",
      image: "",
    });

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const showModalErrors = ref(false);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);
    const store = useStore();
    const createParametersData = computed(
      () => store.getters.getCreateParametersData
    );

    const create = () => {
      if (!canAddParameter.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createParameters", parameterObj.value);
    };

    watch(
      () => createParametersData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router
            .push({ name: "ParametersList", path: "/Parameters" })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Nowy parametr został dodany",
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      canAddParameter,
      parameterObj,
      errorsAdminData,
      showErrors,
      create,
      showModalErrors,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
    };
  },
  computed: {
    chevronPlClass() {
      return this.isPlOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronEnClass() {
      return this.isEnOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeClass() {
      return this.isDeOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeDeClass() {
      return this.isDeDeOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeEnClass() {
      return this.isDeEnOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronConfigClass() {
      return this.isConfigOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
